module.exports = __webpack_public_path__ + "static/media/09B2.f6c2490f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/robots/09B2.png
// module id = 275
// module chunks = 0